<template>
  <div class="list-com">
    <div class="con">
      <li :key="index" @click="handleDetailClick(item)" v-for="(item,index) in list">
        <div class="top">
          <span class="title">{{item.title}}</span>
          <span
            :class="item.overdue == 0 ? 'stateOverdue' : 'stateOverEnd'"
            class="state"
          >{{item.overdueName}}</span>
        </div>
        <div>报修人：{{item.petitionerName}}</div>
        <div class="score" v-if="item.status == 40">
          <van-rate color="#ff5603" readonly v-model="item.appraisalScore" />
          <span>{{item.appraisalScore}}分</span>
        </div>
        <div>
          楼层：{{item.floorName}}&nbsp;&nbsp;
          <!-- <span v-if="$global.uName">{{$global.uName}}</span> -->
        </div>
        <div>报修时间：{{item.petitionTime}}</div>
      </li>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      result: "",
      showPicker: false,
      list: []
    };
  },
  props: {
    listArr: {
      type: Array
    }
  },
  mounted() {
    this.list = this.listArr;
  },
  methods: {
    handleDetailClick(item) {
      this.$emit("jumpInfo", item);
    }
  },
  watch: {
    listArr() {
      this.list = this.listArr;
    }
  }
};
</script>

<style lang="scss" scoped>
.list-com {
  li {
    padding: px2rem(20) 0;
    border-bottom: px2rem(1) solid #efefef;
    > div {
      margin: px2rem(10) 0;
      line-height: px2rem(40);
    }
    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: px2rem(34);
        font-weight: 900;
        width: 70%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .state {
        padding: px2rem(10) px2rem(20);
        background: #0245bf;
        color: #fff;
        border-radius: px2rem(8);
      }
      .stateOverdue {
        background: #0245bf;
      }
      .stateOverEnd {
        background: #f92e93;
      }
    }
  }
  .score {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: px2rem(20) 0 !important;
  }
}
</style>
